import glamorous from "glamorous"
import style from "utils/style"

export default glamorous.h1({
  color: style.colors.almostBlack,
  fontSize: "1.8rem",
  marginBottom: "3rem",
  textAlign: "center",
})



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/FormTitle/index.js